import settings from '../../config/settings';
import axiosNonAuth from './axiosNonAuth';

const {apiBaseUrl} = settings;

export default class StationApi {
  static getChannels(affiliateCallSign, postalCode) {
    return axiosNonAuth.get(`${apiBaseUrl}/stations/${affiliateCallSign}/channels/${postalCode}/`);
  }

  static getAirings(affiliateCallSign, postalCode, gracenoteSeriesId) {
    return axiosNonAuth.get(`${apiBaseUrl}/stations/${affiliateCallSign}/airings/${postalCode}/?gracenote_series_id=${gracenoteSeriesId}`);
  }
}
